export default defineAppConfig({
  // Funnels default to whatever rail the backend answers with; see payments.md.
  chargebeeOnly: false,
  roundOnly: false,
  usPricing: false,
  planSet: '',
  checkoutFormVariant: '',
});

declare module '@nuxt/schema' {
  interface AppConfigInput {
    chargebeeOnly?: boolean
    roundOnly?: boolean
    usPricing?: boolean
    planSet?: string
    checkoutFormVariant?: string
  }
}
